import React, { useEffect, useRef, useState } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { createCustomer, deleteCustomerById, fetchCustomers, updateCustomer } from '../lib/crmClient';

const initial = {
  ZakaznikId: null,
  Nazev: '',
  Ulice: '',
  IC: '',
  KontaktniOsoba: '',
  Telefon: '',
  Email: '',
};

const ZakaznikForm = () => {
  const history = useHistory();
  const { id } = useParams();
  const isEdit = Boolean(id);
  const isMountedRef = useRef(true);

  const [form, setForm] = useState(initial);
  const [saving, setSaving] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => () => {
    isMountedRef.current = false;
  }, []);

  useEffect(() => {
    if (!isEdit) return;

    const run = async () => {
      if (isMountedRef.current) {
        setError('');
      }
      try {
        const list = await fetchCustomers();
        const found = list.find((item) => Number(item.ZakaznikId) === Number(id));
        if (!found) throw new Error('Zákazník nebyl nalezen.');

        if (!isMountedRef.current) return;

        setForm({
          ZakaznikId: found.ZakaznikId,
          Nazev: found.Nazev || '',
          Ulice: found.Ulice || '',
          IC: found.IC || '',
          KontaktniOsoba: found.KontaktniOsoba || '',
          Telefon: found.Telefon || '',
          Email: found.Email || '',
        });
      } catch (e) {
        if (isMountedRef.current) {
          setError(e instanceof Error ? e.message : 'Načtení zákazníka selhalo');
        }
      }
    };

    run();
  }, [id, isEdit]);

  const submit = async (event) => {
    event.preventDefault();
    setSaving(true);
    setError('');

    try {
      if (!form.Nazev.trim()) throw new Error('Vyplňte název zákazníka.');

      const payload = {
        Nazev: form.Nazev.trim(),
        Ulice: form.Ulice.trim() || null,
        IC: form.IC.trim() || null,
        KontaktniOsoba: form.KontaktniOsoba.trim() || null,
        Telefon: form.Telefon.trim() || null,
        Email: form.Email.trim() || null,
      };

      if (isEdit) {
        await updateCustomer({ ...payload, ZakaznikId: Number(form.ZakaznikId || id) });
      } else {
        await createCustomer(payload);
      }

      history.push('/zakaznici');
    } catch (e) {
      if (isMountedRef.current) {
        setError(e instanceof Error ? e.message : 'Uložení zákazníka selhalo');
      }
    } finally {
      if (isMountedRef.current) {
        setSaving(false);
      }
    }
  };

  const handleDelete = async () => {
    const customerId = Number(form.ZakaznikId || id || 0);
    if (!isEdit || !customerId) return;

    const confirmed = window.confirm(
      `Opravdu chcete smazat zákazníka ${form.Nazev || customerId}? Smazání proběhne jen pokud nemá žádnou přiřazenou zakázku.`
    );

    if (!confirmed) return;

    setDeleting(true);
    setError('');

    try {
      await deleteCustomerById(customerId);
      history.push('/zakaznici');
    } catch (e) {
      if (isMountedRef.current) {
        setError(e instanceof Error ? e.message : 'Smazání zákazníka selhalo');
      }
    } finally {
      if (isMountedRef.current) {
        setDeleting(false);
      }
    }
  };

  return (
    <div>
      <h2 className="page-header">{isEdit ? `Editace zákazníka #${id}` : 'Nový zákazník'}</h2>

      <div className="card">
        {error ? <p className="crm-error">{error}</p> : null}

        <form onSubmit={submit} className="form-grid">
          <div className="crm-actions-row">
            <Link to="/zakaznici">Zpět na seznam</Link>
          </div>

          <label>Název firmy / zákazníka</label>
          <input value={form.Nazev} onChange={(e) => setForm((p) => ({ ...p, Nazev: e.target.value }))} required />

          <label>Adresa</label>
          <input value={form.Ulice} onChange={(e) => setForm((p) => ({ ...p, Ulice: e.target.value }))} />

          <label>IČ</label>
          <input value={form.IC} onChange={(e) => setForm((p) => ({ ...p, IC: e.target.value }))} />

          <label>Kontaktní osoba</label>
          <input value={form.KontaktniOsoba} onChange={(e) => setForm((p) => ({ ...p, KontaktniOsoba: e.target.value }))} />

          <label>Telefon</label>
          <input value={form.Telefon} onChange={(e) => setForm((p) => ({ ...p, Telefon: e.target.value }))} />

          <label>Email</label>
          <input type="email" value={form.Email} onChange={(e) => setForm((p) => ({ ...p, Email: e.target.value }))} />

          <div className="crm-actions-row">
            <button className="btn btn-primary" type="submit" disabled={saving}>{saving ? 'Ukládám...' : 'Uložit'}</button>
            {isEdit ? (
              <button className="btn btn-danger" type="button" onClick={handleDelete} disabled={saving || deleting}>
                {deleting ? 'Mažu...' : 'Smazat zákazníka'}
              </button>
            ) : null}
          </div>
        </form>
      </div>
    </div>
  );
};

export default ZakaznikForm;
